import Gator from 'gator';
import { getParents, jump } from '../../General';

Gator(document).on('click', '.scroll-to-next-section', function () {
    const nextSection = getParents(this, '.scroll-to-next-section-parent')[0].nextElementSibling;
    if (nextSection) {
        jump(nextSection, {
            duration: 1000,
        });
    }
});
